import {jsx} from 'panel';

import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectEl} from 'common/components/select';
import {EntryPart} from 'common/widgets/query-entry-section/types';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';
import {MappedPropertyValues} from 'common/report/constants';
import {InputComponent, InputEl} from 'common/components/input';
import {InputChangeEvent} from 'common/components/input/types';

import type {FilterEntryRow} from '../index';

export function FilterListValue(this: FilterEntryRow) {
  const {activeEntry, entryPart} = this.section.state;
  const isOpen = activeEntry === this.index && entryPart === EntryPart.FilterValue;
  const label = this.filter
    .getLabelParts()
    .slice(2)
    .map((item) => item.label)
    .join(` `);

  /**
   * Historically, list filters are always treated as list of strings, which only
   * require a string input, there is one exception where `Messages Sent` renders
   * a value picker for selecting one of the different messages available in the project
   * we handle that case by rendering `mp-properties-value-screen` for now
   */
  if (this.filter.propertyName === MappedPropertyValues.Campaigns) {
    return (
      <SelectEl
        class={{
          'is-placeholder': !this.filter.isValid(),
        }}
        attrs={{
          elref: `filterValueSelect`,
          open: isOpen,
          theme: `select`,
          'selected-option': this.filter.isValid() ? label : `Select value...`,
        }}
        on={{
          menuChange: (ev) => this.section.helpers.onSelectMenuChange(ev, this.index, EntryPart.FilterValue),
        }}
      >
        {isOpen && (
          <PropertyValuesScreenEl
            attrs={{
              elref: `filterValue`,
              slot: `body`,
              'display-value-only': true,
              'event-names': this.section.attr(`event-names`),
              'property-filter': this.filter.getAttributes(),
              'project-id': this.section.attr(`project-id`),
              'workspace-id': this.section.attr(`workspace-id`),
            }}
            on={{
              commitPropertyFilter: (ev: CommitPropertyFilterEvent) =>
                this.handleFilterValueChange(ev.detail.propertyFilter.filterValue),
            }}
          />
        )}
      </SelectEl>
    );
  }

  return (
    <InputEl
      class={{'is-placeholder': !this.filter.isValid()}}
      attrs={{
        elref: `filterInput`,
        placeholder: `value`,
        'select-on-focus': true,
      }}
      props={{value: this.filter.filterValue as string}}
      hook={
        !this.filter.isValid() && {
          update: (node) => requestAnimationFrame(() => (node.elm as InputComponent).focus()),
        }
      }
      on={{
        change: (ev: InputChangeEvent) => {
          // when the upadted value is not a valid input, revert back to previously committed input
          if (ev.detail.value) {
            this.handleFilterValueChange(ev.detail.value);
          } else {
            (ev.target as HTMLInputElement).value = this.filter.filterValue as string;
          }
        },
      }}
    />
  );
}
